import type { DocMigration } from "../docMigration";
import { migrateModelFromStaticRoomLayoutToDoc } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_72: DocMigration = {
  maxSchemaVersion: "0.0.72",
  description: "Refactor casework to extend DocEntityBase and be on top-level document",
  apply(json: any) {
    migrateModelFromStaticRoomLayoutToDoc(json, "casework", "CASEWORK");
    return json;
  },
};

export default migration_0_0_72;
